import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<IVisaPrepForm, 'hasAdditionalPassports' | 'additionalPassports'>;

type Params = Fields;

export function getPageStatus({ hasAdditionalPassports, additionalPassports }: Params): { complete: boolean } {
  let complete = false;
  if (hasAdditionalPassports !== undefined) {
    if (hasAdditionalPassports === false) {
      complete = true;
    } else {
      if (!additionalPassports || additionalPassports.length === 0) {
        complete = false;
      } else {
        complete = !additionalPassports.some(passport => {
          return (
            passport.placeOfIssue === '' ||
            passport.issuingAuthority === '' ||
            passport.docNumber === '' ||
            passport.issueDate === '' ||
            passport.expiryDate === ''
          );
        });
      }
    }
  }

  return { complete };
}
